import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Error from "../Components/Error/Error";
import Garage from "../Pages/Garage/Garage";
import LoginPage from "../Components/Auth/LoginPage";
import RegisterPage from "../Components/Auth/RegisterPage";
import SearchPage from "../Pages/SearchPage/SearchPage";
import Forum from "../Pages/Forum/Forum";
import ProtectedRoute from "./ProtectedRoute";
import UserProfile from "../Pages/UserProfile/UserProfile";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <SearchPage />, errorElement: <Error /> },
      { path: "search", element: <SearchPage />, errorElement: <Error /> },
      { path: "login", element: <LoginPage />, errorElement: <Error />  },
      { path: "register", element: <RegisterPage />, errorElement: <Error />  },
      { path: "forum", element: <Forum />, errorElement: <Error />  },
      { path: "garage", element: <ProtectedRoute><Garage /></ProtectedRoute>, errorElement: <Error />  },
      { path: "userProfile", element: <ProtectedRoute><UserProfile /></ProtectedRoute>, errorElement: <Error />  }
    ],
  },
]);
